import { render, staticRenderFns } from "./DeclineOrder.vue?vue&type=template&id=0bce841a&scoped=true&"
import script from "./DeclineOrder.vue?vue&type=script&lang=js&"
export * from "./DeclineOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce841a",
  null
  
)

export default component.exports